export type NumericInput = number | string | null | undefined;

type ResolveFallbackOptions = {
  fallback: string;
  showFallback: boolean;
  showZeros?: boolean;
  zeroValue?: string;
};

export function resolveFallback({ fallback, showFallback, showZeros, zeroValue }: ResolveFallbackOptions): string {
  if (showZeros && zeroValue !== undefined) return zeroValue;
  if (showFallback) return fallback;
  return "";
}

export function getNumericValue(value: NumericInput): number | null {
  if (value === null || value === undefined) return null;

  const normalizedValue = typeof value === "string" ? value.trim() : value;
  if (normalizedValue === "") return null;

  const numericValue = Number(normalizedValue);
  if (!Number.isFinite(numericValue)) return null;

  return numericValue;
}
